import VueForceNextTick from 'vue-force-next-tick';

export default VueForceNextTick;
